import { Api } from '../helpers';

const searchOrderModel = {
  getSearchOrders(params) {
    const queryParams = params;
    const path = 'order/search';
    return Api.get({ path, queryParams });
  },

  getCustomerAlerts(params) {
    const body = {
      ...params,
    };
    const path = 'order/alerts';
    return Api.post({ path }, { body });
  },

  getBlinkitIdForZomatoUser(queryParams) {
    const path = 'intiator/get_blinkit_user_id';
    return Api.get({ path, queryParams });
  },
};

export default searchOrderModel;
